import React from 'react';
import { useFormContext } from 'react-hook-form';

import { FormFields } from '../../AccountForm.meta';
import { Input } from '../../../../../../../../CommonComponents/OPL/Input/Input';

export const AnnuityIndexName = () => {
  const { register } = useFormContext<FormFields>();

  return <Input {...register('bankAccount.AnnuityIndexName')} label="Index Name" />;
};
